import { Middleware } from "../middleware"

export default {
    getUserProfileInfo() {
        return new Middleware()
            .method('GET')
            .append(`/user_profile/`)
            .build()
    },
    updateInfos(data) {
        return new Middleware()
            .method('PUT')
            .append(`/user_profile/`)
            .setData(data)
            .build()

    }


}